import {autoinject, transient, useView} from "aurelia-framework";
import { CompanyModel } from "../../../../../../models/companies/company.models";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { SafetyScoreDocScores } from "../../../vessels/steps/safety-score-tabs/safety-score-doc-scores";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { DocPerformanceStep } from "../doc-performance-step/doc-performance-step";
import { CompanyVesselPerformance } from "../company-vessel-performance/company-vessel-performance";
import { ClaimsRequireTypeEnum } from "../../../../../../models/basics/basics.models";

class CompanyDocPerformanceTab {
    title: string;
    vm: any;
    model?: any;
    isVisible: boolean;
    key?: string;
}

@autoinject
@transient()
@useView('views/pages/modules/company/steps/doc-performance/doc-performance.html')
export class DocPerformance {

    constructor(private docScores: SafetyScoreDocScores, private docPerformanceStep:DocPerformanceStep,
        private companyVesselPerformance: CompanyVesselPerformance, private userClaimsService: UserClaimsService) {
    }

    tabs: CompanyDocPerformanceTab[] = [];
    currentTab: CompanyDocPerformanceTab;
    model: CompanyModel;

    async activate(model: CompanyModel) {
        this.model = model;
        this.tabs = [
            {
                title: "DOC fleet",
                vm: this.companyVesselPerformance,
                model: this.model,
                isVisible: this.userClaimsService.hasPermissions([Claims.CanAccessDOCFleetOverview, Claims.CanAccessDOCFleetTable], ClaimsRequireTypeEnum.RequireAny)
            },
            {
                title: "DOC subscores",
                vm: this.docScores,
                model: {
                    company: this.model
                },
                isVisible: this.userClaimsService.hasPermission(Claims.CanAccessSafetyScoreDocScores)
            },
            {
                title: "DOC INC/PSC report (RS only)",
                vm: this.docPerformanceStep,
                model: this.model,
                isVisible: this.userClaimsService.hasPermission(Claims.DocAndVesselPerformanceReports)
            }
        ];

        if(this.tabs.filter(x => x.isVisible).length > 0)
            this.navigateToTab(this.tabs.filter(x => x.isVisible)[0]);
    }

    navigateToTab(tab: CompanyDocPerformanceTab) {
        this.currentTab = tab;
        this.scrollToTop();
    }

    scrollToTop() {
        const scrollElement = MobileHelper.getScrollParent(document.getElementsByClassName('page-company').item(0), false) as HTMLDivElement;

        setTimeout(() => {
            if (scrollElement) {
                scrollElement.scrollTop = 0;
            }
        });
    }
}